import { useParams } from 'react-router';
/**
 * @returns the buildingPackageId from the current route (url)
 */
export const useBuildingPackageId = () => {
    const { buildingPackageId } = useParams();
    if (buildingPackageId == null) {
        throw new Error(`useBuildingPackageId called with invalid :buildingPackageId (${buildingPackageId})`);
    }
    return buildingPackageId;
};
